<template>
    <v-dialog v-model="manageDeleteBookingDialog" width="30%" persistent>
        <v-card>
            <v-card-title>Delete Booking</v-card-title>
            <v-card-text>
                Are you sure you want to delete this booking?
                <strong>This action cannot be undone</strong>
                <p>Enter {{stringCode}} below to confirm deletion</p>
                <v-text-field label="Code" v-model="enteredCode" :rules="[v => !!v || 'This field is required']" />
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel
                </v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading || enteredCode.length === 0" color="error" @click="deleteBooking">Delete Booking
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex";
    import {BookingsHttp} from "../../http/BookingsHttp";
    import EventBus from '../../EventBus';

    export default {
        name: "DeleteBookingModal",
        computed: {
            ...mapState('bookings', ['manageDeleteBookingDialog', 'activeBooking'])
        },
        data() {
            return {
                isLoading: false,
                stringCode: '',
                enteredCode: ''
            }
        },
        watch: {
            manageDeleteBookingDialog(newVal) {
                if (newVal) {
                    this.stringCode = this.makeid(5);
                }
            }
        },
        methods: {
            ...mapActions("bookings", ["setManageDeleteBookingDialog", "setActiveBooking", "setBookings"]),
            ...mapMutations("app", ["setToast"]),
            async closeDialog() {
                this.enteredCode = '';
                this.stringCode = '';
                await this.setManageDeleteBookingDialog(false);
            },
            async deleteBooking() {
                if (this.enteredCode === this.stringCode) {
                    try {
                        this.isLoading = true;
                        await BookingsHttp.deleteBooking(this.activeBooking._id);
                        this.enteredCode = '';
                        this.stringCode = '';
                        await this.setBookings(this.activeBooking.startDate);
                        await this.setActiveBooking({isXeroBooking: true, customer: {}});
                        await this.setManageDeleteBookingDialog(false);
                        EventBus.$emit('booking-deleted');
                        this.setToast({color: 'success', text: 'Deleted Booking successfully', show: true});
                    } catch (err) {
                        this.setToast({color: 'error', text: err.response.data, show: true})
                    } finally {
                        this.isLoading = false;
                    }
                }
            },
            makeid(length) {
                let result           = '';
                let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let charactersLength = characters.length;
                for ( let i = 0; i < length; i++ ) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            }
        }
    }
</script>